import { Link, useMatches } from "react-router";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export function LandingNavRight() {
  const { t } = useTranslation();
  const matches = useMatches();
  const isLoggedIn: boolean = (matches[0]?.data as any)?.loggedIn ?? false;
  const isPharmacySection = matches.some((m) => (m.handle as any)?.pharmacySection);
  const linkTo = isLoggedIn ? "/client/dashboard" : isPharmacySection ? "/v1/auth/login" : "/register/pharmacy";
  const label = isLoggedIn ? t("Startseite") : isPharmacySection ? t("Login") : t("Apotheken Bereich");

  return (
    <Link
      to={linkTo}
      className="inline-flex items-center justify-center gap-1 rounded-xl bg-blue-550 px-5 py-2.5 text-sm font-semibold text-white shadow-lg shadow-blue-800/20 transition hover:-translate-y-0.5 hover:bg-blue-900"
    >
      {label}
      <ArrowRight className="h-4 w-4" aria-hidden="true" />
    </Link>
  );
}
